export const DBT_FILES_ROOT_NODE_NAME = 'dbt-files';
export const DBT_ASSETS_ROOT_NODE_NAME = 'dbt-assets';
export const DBT_DATABASE_ROOT_NODE_NAME = 'dbt-databases';
export const DBT_ROOT_NODE_LABEL = 'dbt';
export const PROJECT_PAGE_SIZE = 20;
export const RESOURCE_PAGE_SIZE = 5;

export const VALID_FILE_TYPES = {
  ASSETS: [
    'model',
    'source',
    'test',
    'exposure',
    'group',
    'metric',
    'semantic_model',
    'seed',
    'macro',
    'snapshot',
    'saved_query',
  ],
  WAREHOUSE_ENTITIES: ['connection', 'database', 'project', 'schema'],
  PROJECTS: ['project'],
};

export type ValidFileType =
  | (typeof VALID_FILE_TYPES.ASSETS)[number]
  | (typeof VALID_FILE_TYPES.WAREHOUSE_ENTITIES)[number]
  | (typeof VALID_FILE_TYPES.PROJECTS)[number];

export const isValidFileType = (fileType: string): fileType is ValidFileType => {
  return Object.values(VALID_FILE_TYPES).some((types) => types.includes(fileType));
};
